import {atom} from "recoil";

const dateJoined = atom(({
    key: "accountDateJoinedAtom",
    default: null 
}));

export default dateJoined;